import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/charge/user/userList', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/charge/user/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/charge/user/remove', qs.stringify(params), options);

export const removePermission = (params, options) =>
  request.post('/api/v4ward/charge/user/removePermission', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/charge/user/save', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/charge/user/update', params, options);
//
export const submit = (params, options) =>
  request.post('/api/v4ward/charge/user/submit', params, options);

export const getUserDetail = (params, options) =>
  request.get('/api/v4ward/charge/user/getUserDetail', Object.assign({}, options, { params }));

export const getDictList = (params, options) =>
  request.get('/api/v4ward/charge/user/getFeeTypes', Object.assign({}, options, { params }));

//关联销售方信息
export const linkSeller = (params, options) =>
  request.post('/api/v4ward/charge/user/link-seller', params,options)
